import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Card, CardContent, CardActions, Typography, Button, withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const styles = theme => ({
  messageCard: {
    maxWidth: 475,
    margin: '32px auto'
  }
});

const MessageCard = (props) => {
  const { error, classes, textBtn, url, message, body } = props;
  const { t } = useTranslation();

  return (
    <Card className={classes.messageCard}>
      <CardContent>
        <Typography component='h4'>
          {error ? t('messageCard:thereWasAnError') : message}
        </Typography>
        <Typography component='p'>
          {body}
        </Typography>
      </CardContent>
      {!error && url && url !== '/document' && (<CardActions>
        <Button size='small' color='primary' component={RouterLink} to={url}>{textBtn}</Button>
      </CardActions>)}
    </Card>
  );
};

export default withStyles(styles, { theme: true })(MessageCard);
